
import {
  computed,
  defineComponent,
  onMounted,
  onBeforeUnmount,
  reactive, ref,
} from 'vue';
import { useStore } from 'vuex';
import DistrictOfficeInterface from '@/interfaces/DistrictOfficeInterface';
import LazyImage from '@/components/LazyImage.vue';

export default defineComponent({
  components: {
    LazyImage,
  },

  props: {
    contactPersonId: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const root = ref<InstanceType<typeof HTMLElement>>();
    const store = useStore();

    const contactPerson = computed<DistrictOfficeInterface>(() => store.getters['contactPersons/contactPerson'](parseInt(props.contactPersonId, 10)));

    const sizeClasses = reactive({ value: [] as string[] });

    const setSizeClass = () => {
      sizeClasses.value = [];

      if (root.value) {
        const elementWidth = root.value.scrollWidth;
        if (elementWidth >= 680) {
          sizeClasses.value.push('wide');
        }
      }
    };

    const classes = computed(() => {
      const cls = [...sizeClasses.value];
      if (contactPerson.value === null) {
        cls.push('loading');
      }
      return cls;
    });

    onMounted(() => {
      window.addEventListener('resize', setSizeClass);
      window.addEventListener('load', setSizeClass);
      setSizeClass();
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setSizeClass);
      window.removeEventListener('load', setSizeClass);
    });

    const getImageFormats = (imageUrl: string) => {
      if (imageUrl.endsWith('.jpg')) {
        return ['jpg'];
      }
      if (imageUrl.endsWith('.png')) {
        return ['png'];
      }

      return ['webp'];
    };

    const getImageSrc = (imageUrl: string) => {
      if (imageUrl.endsWith('.webp')) {
        return imageUrl.substr(0, imageUrl.length - 5);
      }

      return imageUrl.substr(0, imageUrl.length - 4);
    };

    const getPhoneRef = (phonenumber: string) => {
      let phonenumberFormatted = phonenumber;

      if (phonenumberFormatted.startsWith('0')) {
        phonenumberFormatted = `+49${phonenumberFormatted.substr(1)}`;
      }

      return `tel:${phonenumberFormatted.replace(' ', '')}`;
    };

    return {
      root,
      store,
      contactPerson,
      sizeClasses,
      classes,
      getImageFormats,
      getPhoneRef,
      getImageSrc,
    };
  },
});
